"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$EmailRequestDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$EmailRequestDto = {
    properties: {
        to: {
            type: 'array',
            contains: {
                type: 'string',
            },
            isRequired: true,
        },
        subject: {
            type: 'string',
            description: `Subject or summary to email`,
            isRequired: true,
        },
        title: {
            type: 'string',
            description: `Title inside the email`,
            isRequired: true,
        },
        message: {
            type: 'string',
            description: `Message or body inside the email`,
            isRequired: true,
        },
        url: {
            type: 'string',
            description: `URL to redirect when user click the email`,
            isRequired: true,
        },
        lang: {
            type: 'Enum',
            isRequired: true,
        },
    },
};
